// Output-panel event helpers.
//
// Panel `events` entries are heterogeneous: a card can arrive as a JS OBJECT or
// as a card JSON STRING, and plain-text progress lines ("Invoking <fn>…") can
// trail the newest card. Consumers that need the current card must parse each
// entry and scan back to the newest real one — reading a raw entry's fields
// directly is the bug that made the drawer-collapse signal silently no-op.
//
// (This is the seam the proposed panel-event-contract ADR would formalize; for
// now it's the single place that knows how to read a panel entry.)

/** Coerce one panel entry to a card object, or null if it isn't a card. */
export function parsePanelCard(entry) {
  if (entry && typeof entry === 'object') return entry.kind ? entry : null;
  try {
    const parsed = JSON.parse(entry);
    return parsed && parsed.kind ? parsed : null;
  } catch (e) {
    return null; // plain-text progress / non-JSON
  }
}

/** The newest card in the panel stream (skipping trailing progress), or null. */
export function newestPanelCard(events) {
  for (let i = (events ? events.length : 0) - 1; i >= 0; i--) {
    const card = parsePanelCard(events[i]);
    if (card) return card;
  }
  return null;
}

/** True when a card action leaves a required parameter for the chat to ask (e.g. a claim's
 *  contact): the user answers in the conversation, so the drawer should get out of the way. */
export function actionAsksInChat(action) {
  const required = (action && action.parameters && action.parameters.required) || [];
  const prefilled = (action && action.prefilled) || {};
  return required.some((p) => !(p in prefilled));
}

/** The window event a card action fires to send the user back to the chat. */
export const CARD_TO_CHAT = 'aveq:card-to-chat';
